import { ClosedLostSubmit } from './ClosedLostQuickForm'
import { CLOSE_LOST_MUTATION } from './graphql'
import { gqlMutation } from 'app/lib/graphqlClient'
import { isSMCOrg } from 'lib/isSMCOrg'

/** Closes a lead lost via updateContact. Throws on failure so callers can roll back. */
export async function createClosedLostMilestone(
  contactId: string,
  orgId: string | undefined,
  data: ClosedLostSubmit,
): Promise<void> {
  const result = await gqlMutation(CLOSE_LOST_MUTATION, {
    id: contactId,
    input: {
      leadStatus: `Closed Lost`,
      closedLostReason: data.closedLostReason,
      isQualified: isSMCOrg(orgId ?? ``)
        ? ![`Service Not Offered`, `Insurance: State / HMO`, `Office Too Far`].includes(data.closedLostReason)
        : data.disqualified === `false`,
      note: data.note,
      ownerId: data.owner?.id,
      ownerName: data.owner?.name,
    },
  })
  if (result.error || !result.data?.updateContact) {
    throw new Error(result.error?.message ?? `Closed Lost did not save`)
  }
}
